{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Predlošci",
    "DESCRIPTION": "Pregledajte predloške poruka sinkronizirane iz vaših WhatsApp sandučića. Za izradu ili uređivanje predloška obratite se svom pružatelju usluge.",
    "COUNT": "Predložaka: {n}",
    "LEARN_MORE": "Saznajte više o WhatsApp predlošcima",
    "SYNC_TEMPLATES": "Sinkroniziraj predloške",
    "SYNC_SUCCESS": "Sinkronizacija predložaka pokrenuta je za sve WhatsApp sandučiće. Ažuriranja mogu potrajati nekoliko minuta.",
    "PARTIAL_SYNC_ERROR": "Sinkronizacija predložaka pokrenuta je za neke WhatsApp sandučiće, no ostale nije bilo moguće sinkronizirati.",
    "SYNC_ERROR": "Nije moguće pokrenuti sinkronizaciju predložaka. Pokušajte ponovno.",
    "SEARCH_PLACEHOLDER": "Pretraži po sadržaju ili nazivu...",
    "MANAGE_IN_META": "Upravljaj u Meta",
    "LOADING": "Učitavanje WhatsApp predložaka...",
    "EMPTY": "Nisu pronađeni WhatsApp predlošci.",
    "NO_RESULTS": "Nijedan predložak ne odgovara vašim filtrima.",
    "FETCH_ERROR": "Nije moguće učitati WhatsApp predloške. Pokušajte ponovno.",
    "PARTIAL_FETCH_ERROR": "Neke WhatsApp predloške nije bilo moguće učitati. Pokušajte ponovno.",
    "LAST_SYNC_ATTEMPT": "Zadnji pokušaj sinkronizacije: {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Nije poslano na WhatsApp odobrenje"
    },
    "FILTERS": {
      "ALL_INBOXES": "Svi sandučići",
      "ALL_LANGUAGES": "Svi jezici",
      "ALL_TYPES": "Sve vrste"
    },
    "TYPES": {
      "TEXT": "Tekst",
      "IMAGE": "Slika",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Poziv na akciju",
      "COPY_CODE": "Kopiraj kod"
    },
    "PREVIEW": {
      "TITLE": "Pregled predloška",
      "DESCRIPTION": "Pregledajte kako ovaj predložak izgleda u WhatsAppu.",
      "OPEN": "Pregled {name}",
      "CLOSE": "Zatvori pregled",
      "DETAILS": "Detalji predloška",
      "STATUS": "Status",
      "TYPE": "Vrsta sadržaja",
      "CATEGORY": "Kategorija",
      "LANGUAGE": "Jezik",
      "INBOXES": "Sandučići"
    }
  }
}
